export const BUSINESS = {
    name: "Fontanería Rodrigo S.L.",
    shortName: "Fontanería Rodrigo",
    tagline: "Fontanería y calefacción",
    cif: "B71001184",
    phone: "606 246 037",
    phoneHref: "tel:+34606246037",
    email: "fontaneriarodrigo@live.com",
    emailHref: "mailto:fontaneriarodrigo@live.com",
    address: "Pol. Ind. Aloa, Calle A, Nave B",
    city: "Puente la Reina",
    province: "Navarra",
    postalCode: "31100",
    country: "España",
    hours: "Lunes a viernes · 8:00 – 17:30",
    mapsQuery:
        "Pol. Ind. Aloa, Calle A, Nave B, 31100 Puente la Reina, Navarra",
};

export const SERVICES = [
    {
        id: "caldera",
        title: "Cambios de caldera",
        tagline: "Renovación integral con máxima eficiencia",
        description:
            "Sustitución de calderas antiguas por modelos de condensación de alto rendimiento. Gestión de documentación, retirada de la antigua y puesta en marcha.",
        bullets: [
            "Calderas de condensación de gas",
            "Estudio previo y presupuesto sin compromiso",
            "Retirada del equipo anterior incluida",
        ],
        icon: "Flame",
    },
    {
        id: "calefaccion",
        title: "Instalación de calefacción",
        tagline: "Sistemas completos a medida",
        description:
            "Proyectamos e instalamos la calefacción de tu vivienda o local: diseño hidráulico, selección de equipos y puesta en servicio llave en mano.",
        bullets: [
            "Instalaciones nuevas y reformas",
            "Cálculo de necesidades térmicas",
            "Regulación y equilibrado de circuitos",
        ],
        icon: "Thermometer",
    },
    {
        id: "radiadores",
        title: "Radiadores",
        tagline: "Confort en cada estancia",
        description:
            "Sustitución e instalación de radiadores de aluminio, acero o toalleros. Optimizamos el rendimiento y la estética en cada habitación.",
        bullets: [
            "Radiadores de aluminio y acero",
            "Toalleros para baño",
            "Válvulas termostáticas",
        ],
        icon: "Grid3x3",
    },
    {
        id: "suelo-radiante",
        title: "Suelo radiante",
        tagline: "Calor uniforme y eficiencia máxima",
        description:
            "Instalación de suelo radiante por agua caliente: mayor eficiencia energética, reparto homogéneo del calor y total libertad de decoración.",
        bullets: [
            "Instalación en obra nueva y reformas",
            "Colectores y circuitos optimizados",
            "Compatibilidad con aerotermia",
        ],
        icon: "LayoutGrid",
    },
    {
        id: "aerotermia",
        title: "Aerotermia",
        tagline: "Climatización renovable",
        description:
            "Sistemas de aerotermia para calefacción, refrigeración y ACS. Ahorro energético, reducción de emisiones y confort todo el año.",
        bullets: [
            "Bombas de calor aire-agua",
            "Integración con suelo radiante",
            "Asesoramiento sobre ayudas y subvenciones",
        ],
        icon: "Wind",
    },
    {
        id: "gas",
        title: "Instalaciones de gas",
        tagline: "Seguridad certificada",
        description:
            "Instalaciones, modificaciones, revisiones y certificaciones de gas natural y propano para viviendas y negocios, cumpliendo la normativa vigente.",
        bullets: [
            "Nuevas acometidas y ampliaciones",
            "Pruebas de estanqueidad",
            "Certificados oficiales",
        ],
        icon: "Zap",
    },
    {
        id: "banos",
        title: "Baños completos",
        tagline: "Reformas integrales llave en mano",
        description:
            "Reforma completa de baños: alicatado, sanitarios, mamparas, mobiliario y fontanería. Coordinamos cada oficio para que tú no tengas que hacerlo.",
        bullets: [
            "Diseño y asesoramiento",
            "Obra y fontanería integrada",
            "Acabados de calidad",
        ],
        icon: "Bath",
    },
];

/* Curated selection of real work photos. Files live at /assets/gallery/work-N.jpg.
   Ordered to showcase variety: industrial, aerotermia, calderas, suelo radiante,
   radiadores, cocinas, baños. No duplicates or near-duplicates of the same job. */
const GALLERY_PICKS = [
    { n: 23, alt: "Instalación industrial en nave" },
    { n: 2, alt: "Trabajo industrial - estructura" },
    { n: 11, alt: "Instalación de tuberías industriales" },
    { n: 21, alt: "Instalación de aire acondicionado - unidad exterior" },
    { n: 33, alt: "Instalación de caldera de condensación" },
    { n: 22, alt: "Sala de calderas e instalación de gas" },
    { n: 35, alt: "Colectores de suelo radiante" },
    { n: 41, alt: "Tuberías de suelo radiante en obra" },
    { n: 1, alt: "Radiador toallero instalado" },
    { n: 39, alt: "Radiador de aluminio" },
    { n: 28, alt: "Instalación de contadores de gas" },
    { n: 10, alt: "Instalación de cocina - encimera y fregadero" },
    { n: 16, alt: "Fregadero de cocina" },
    { n: 34, alt: "Reforma integral de baño" },
    { n: 26, alt: "Baño reformado con alicatado" },
    { n: 19, alt: "Plato de ducha nuevo" },
    { n: 27, alt: "Plato de ducha con desagüe" },
    { n: 6, alt: "Grifería de ducha" },
    { n: 29, alt: "Baño con inodoro y bidé" },
    { n: 18, alt: "Lavabo e inodoro en baño reformado" },
];

export const GALLERY = GALLERY_PICKS.map(({ n, alt }) => ({
    src: `/assets/gallery/work-${n}.jpg`,
    alt: `Fontanería Rodrigo — ${alt}`,
}));
